import { campaignRouterMap, useCampaignRouterConfig } from "@BZA/Campaign/router";
import { routeConfig } from "@/routes/route";
import { Suspense, lazy } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LazyLoad = (path: string) => {
  const Comp = lazy(() => import("@BZA/" + path));
  return (
    <Suspense fallback={<></>}>
      <Comp />
    </Suspense>
  );
};

// 重定向组件 - 保留查询参数
const RedirectToOrder = () => {
  const location = useLocation();
  return <Navigate to={`/order${location.search}`} replace />;
};

// 生成路由配置的函数
export const useAIDRouterConfig = () => {
  const { t } = useTranslation();
  const campaignRoutes = useCampaignRouterConfig();

  return [
    {
      path: "/order",
      element: LazyLoad("Order/index"),
      name: t("routes.inquiryManagement"),
      key: "AddToShoppingListKey",
      icon: "AddToShoppingList",
    },
    {
      path: "/order/creativeInquiry/:productId",
      element: LazyLoad("Order/creativeInquiry"),
      name: t("routes.fillInquiry"),
      editName: t("routes.editInquiry"),
      key: "AdCreative",
      isHidden: true,
      fromPath: "/order",
      pathReg: /\/order\/productId\/\d+/,
    },
    {
      path: "/order/editInquiry/:inquiryId/:productId",
      element: LazyLoad("Order/creativeInquiry"),
      name: t("routes.editInquiry"),
      key: "EditAdCreative",
      editName: t("routes.editInquiry"),
      isHidden: true,
      fromPath: "/order",
      pathReg: /\/order\/editInquiry\/\d+\/\d+/,
    },
    {
      path: "/order/inquirydetails/:status/:inquiryId/:productId",
      element: LazyLoad("Order/inquirydetailed"),
      name: t("routes.inquiryDetails"),
      key: "inquirydetails",
      isHidden: true,
      fromPath: "/order",
      pathReg: /\/order\/inquirydetails\/\d+\/\d+/,
    }, {
      path: "/order/details/:status/:inquiryId/:productId",
      element: LazyLoad("Order/detailedInformation"),
      name: t("routes.orderDetails"),
      key: "details",
      isHidden: true,
      fromPath: "/order",
      pathReg: /\/order\/details\/\d+\/\d+/,
    },
    ...campaignRoutes,
    {
      path: "/order/storeorder",
      element: <RedirectToOrder />,
      name: t("routes.appStore"),
      key: "storeorder",
      isHidden: true,
      fromPath: "/order",
    },
    {
      path: "/order/storeorder/:productId",
      element: LazyLoad("Order/Store/Order/index"),
      name: t("routes.myOrder"),
      key: "myorder",
      isHidden: true,
      fromPath: "/order",
      pathReg: /\/order\/productId\/\d+/,
    },
    {
      path: "/order/storeorder/orderform/:productId/:orderId",
      element: LazyLoad("Order/Store/OrderForm/index"),
      name: t("routes.placeOrder"),
      key: "placeOrder",
      isHidden: true,
      fromPath: "/order",
      pathReg: /\/order\/storeorder\/orderform\/\d+\/\d+/,
    }
  ];
};

// 为了向后兼容，保留原有的导出（但建议使用useAIDRouterConfig）
export const AIDRoutercampaignRouterMap: routeConfig[] = [
  {
    path: "/order",
    element: LazyLoad("Order/index"),
    name: "询价管理",
    key: "AddToShoppingListKey",
    icon: "AddToShoppingList",
  },
  {
    path: "/order/creativeInquiry/:productId",
    element: LazyLoad("Order/creativeInquiry"),
    name: "填写询单",
    editName: "编辑填写询单",
    key: "AdCreative",
    isHidden: true,
    fromPath: "/order",
    pathReg: /\/order\/productId\/\d+/,
  },
  {
    path: "/order/editInquiry/:inquiryId/:productId",
    element: LazyLoad("Order/creativeInquiry"),
    name: "编辑填写询单",
    key: "EditAdCreative",
    editName: "编辑填写询单",
    isHidden: true,
    fromPath: "/order",
    pathReg: /\/order\/editInquiry\/\d+\/\d+/,
  },
  {
    path: "/order/inquirydetails/:status/:inquiryId/:productId",
    element: LazyLoad("Order/inquirydetailed"),
    name: "询单详情",
    key: "inquirydetails",
    isHidden: true,
    fromPath: "/order",
    pathReg: /\/order\/inquirydetails\/\d+\/\d+/,
  }, {
    path: "/order/details/:status/:inquiryId/:productId",
    element: LazyLoad("Order/detailedInformation"),
    name: "订单详情",
    key: "details",
    isHidden: true,
    fromPath: "/order",
    pathReg: /\/order\/details\/\d+\/\d+/,
  },
  ...campaignRouterMap,
  {
    path: "/order/storeorder",
    element: <RedirectToOrder />,
    name: "应用商店",
    key: "storeorder",
    isHidden: true,
    fromPath: "/order",
  },
  {
    path: "/order/storeorder/:productId",
    element: LazyLoad("Order/Store/Order/index"),
    name: "我的订单",
    key: "myorder",
    isHidden: true,
    fromPath: "/order",
    pathReg: /\/order\/productId\/\d+/,
  },
  {
    path: "/order/storeorder/orderform/:productId/:orderId",
    element: LazyLoad("Order/Store/OrderForm/index"),
    name: "下单",
    key: "placeOrder",
    isHidden: true,
    fromPath: "/order",
    pathReg: /\/order\/storeorder\/orderform\/\d+\/\d+/,
  }
];
